export const Dashboard_Utility = {
    SESSIONCOMPLETE: 'Sessions Complete',
    TOTAL: 'Total',
    COMPLETE:'Complete',
    CANCELLED:'Cancelled',
    SESSION_BY_TYPE:'Sessions by Type',
    GENERAL:'General',
    DETAILED:'Detailed',
    FOLLOW_UP:'Follow-up'
  };